import { render, staticRenderFns } from "./InnerChatMessage.vue?vue&type=template&id=0b70abe3"
import script from "./InnerChatMessage.vue?vue&type=script&lang=js"
export * from "./InnerChatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports